import React, { useCallback, useEffect, useState } from "react";

import "../../shared/css/basicStyles.css";

import { getAllCollections } from "../../shared/api/request";
import AllCollectionVisual from "../components/AllCollectionVisual";
import { Collection } from "../../shared/types/Collection";

const AllCollection = () => {
  const [data, setData] = useState<Collection[] | undefined>();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const loader = useCallback(async () => {
    setIsLoading(true);
    setHasError(false);
    const res = await getAllCollections();
    if (res?.data) setData(res.data);
    else setHasError(true);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loader();
  }, [loader]);

  return (
    <div className="mainContainer">
      <AllCollectionVisual isLoading={isLoading} hasError={hasError} data={data} onRetry={loader} />
    </div>
  );
};

export default AllCollection;
